import React from 'react';
import Preloader from './component';

export default React.memo(Preloader);
